import { render, staticRenderFns } from "./home-index.vue?vue&type=template&id=5561cad1&"
import script from "./home-index.vue?vue&type=script&lang=js&"
export * from "./home-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports